import EntityFindAndReplace from "containers/entity/EntityFindAndReplace";
import EntityList from "containers/entity/EntityList";
import React, { Component } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import 'react-table/react-table.css';




export default class EntitySearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            state: '',
            name: '',
            acn: '',
            contactname: '',
            isLoading: true,
            Entitys: [],
            filter: {},
            showEntityFindAndReplace: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        document.title = "Cityscope Entity Search";
        this.setState({ isLoading: false });      
    }


    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

   

    handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        console.log(this.state.filter);
 

        this.setState(state => ({
                        filter : {
                            state: this.state.state,
                            name: this.state.name,
                            contactname : this.state.contactname
                        }
        }));

        console.log(this.state.filter);
        

     }

     handleEnityFindAndReplace = event =>{
        
        this.setState({ showEntityFindAndReplace: !this.state.showEntityFindAndReplace });
     }

    renderEntitys() {
        return (
            <div>
            <div>
            {this.state.showEntityFindAndReplace &&
                <Modal
                show={this.state.showEntityFindAndReplace}
                onHide={this.handleEnityFindAndReplace}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Find &amp; Replace Entity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EntityFindAndReplace 
                      isAuthenticated={this.props.isAuthenticated}
                      user={this.props.user}
                    />
          
                    </Modal.Body>
            </Modal>
            }
            </div>
                <Container fluid >
                <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Entity Search
                                </h6>
                    
                        </Col>
                    </Row>
                    
                        

                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        
                        <Col lg={2}>
                            <Form.Group controlId="state">
                                <Form.Control
                                    value={this.state.state}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="State"
                                />
                            </Form.Group>
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="name">
                                <Form.Control
                                    type="input"
                                    value={this.state.name}
                                    onChange={this.handleChange}
                                    placeholder="Entity Name/Entity Code containing" />
                            
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                        <Form.Group controlId="contactname">
                                <Form.Control
                                    type="input"
                                    value={this.state.contactname}
                                    onChange={this.handleChange}
                                    placeholder="Entity Contact Name containing" />
                            
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                        <Button type="submit" className="float-left">Search</Button>
                        </Col>
                        
                        <Col>
                            <Button type="button" onClick={this.handleEnityFindAndReplace}>Entity Find &amp; Replace</Button>
                        </Col>

                    </Form.Row>
                </Form>
                        

                    <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>

                            <EntityList
                            filter={this.state.filter}
                            isAuthenticated={this.props.isAuthenticated}
                            isLoading={this.state.isLoading}
                            properties={this.props.properties}
                            controlType="table"
                        />

                        </Col>
                    </Row>
                </Container>
                </div>

        );
    }
  render() {
    return (

        <div className="EntitySearch">
            {this.props.isAuthenticated ? this.renderEntitys() : console.log("error)")}
        </div>
    );
  }
}
